<ninety-card *ngrxLet="csvExportResult$ as csvExportResult" class="ninety-card">
  <ninety-card-header header>
    <div class="terra-title">Export Company Data as CSV</div>
    <terra-form-field>
      <terra-text-input
        [formControl]="companyIdToExportSearch"
        placeholder="Enter company ID"
        (keydown.enter)="findCompanyById()">
        <terra-input-prefix class="search-icon">
          <terra-icon icon="search" />
        </terra-input-prefix>
      </terra-text-input>
      @if (companyIdToExportSearch.errors?.isObjectId) {
        <terra-error>Please enter a valid object id</terra-error>
      }
    </terra-form-field>
  </ninety-card-header>

  @if (companyToExport) {
    <div class="card-content">
      <div class="found-company">
        @if (companyToExport.logo?.url) {
          <img [src]="companyToExport.logo.url" alt="company logo" class="company-logo" loading="lazy" />
        }
        <div class="flex1">
          {{ companyToExport.name }}
        </div>
        <ninety-button filled primary (click)="exportDirectoryCsv()">
          <terra-icon icon="download" />
          Directory CSV
        </ninety-button>
        <ninety-button filled primary (click)="exportSeatsCsv()">
          <terra-icon icon="seat" />
          Seats CSV
        </ninety-button>
      </div>
    </div>
  }

  <div class="flex-1">
    @for (line of csvExportResult.split('\n'); track $index) {
      <div class="left-space-16">
        {{ line }}
      </div>
    }
  </div>
</ninety-card>
